import api from '../axios';
/* eslint-disable */
export const apiGetVideoInfo = params => api.post('/video/getVodVideoInfo', params);
// 视频观看上报
export const apiReportVideoView = params => api.post('/user/view/report', params);